export const modalId = 'CollectBulkRecurrenceTargetRangeModal'
